module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Trapped in Heavens")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#foreword"
    }
  }, [_vm._v("Foreword")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-itsy-bitsy-flight-through-heavens"
    }
  }, [_vm._v("Chapter 1 Itsy Bitsy Flight Through Heavens")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-big-bang-big-crunch"
    }
  }, [_vm._v("Chapter 2 Big Bang, Big Crunch?")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-3-an-idea"
    }
  }, [_vm._v("Chapter 3 An Idea")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-4-education"
    }
  }, [_vm._v("Chapter 4 Education")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-5-computerized-laser-scanner-cls"
    }
  }, [_vm._v("Chapter 5 Computerized Laser Scanner (CLS)")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#chapter-6-disassembler"
    }
  }, [_vm._v("Chapter 6 ‘Disassembler’")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-7-a-quirk-of-fate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 A Quirk of Fate")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-8-the-search",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 ‘The Search’")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-9-trials-and-tribulations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 Trials and Tribulations")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-10-diagnosis-prognosis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 Diagnosis, Prognosis")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-11-hypothesis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 Hypothesis")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-12-encounter-of-a-different-kind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 Encounter of a Different Kind")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-13-some-answers-and-more-questions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 Some Answers and More Questions")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-14-media-blitz",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 Media Blitz")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-15-more-questions-and-some-answers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 More Questions and Some Answers")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-16-time-to-travel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 Time to Travel")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-17-furor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 Furor")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-18-a-meeting-of-the-minds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 A Meeting of the Minds")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-19-who-what-iswhen-what-did",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 Who What is…When What Did?")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-20-recognition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 Recognition")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-21-family-affair",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 Family Affair")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0